import { z } from "zod";

export const workspaceInviteSchema = z.object({
  workspace_id: z
    .number({
      required_error: "Workspace is required",
      invalid_type_error: "Please select a valid workspace",
    })
    .min(1, "Workspace is required"),
  emails: z
    .array(z.string())
    .min(1, "At least one email is required")
    .max(50, "Cannot invite more than 50 people at once")
    .superRefine((emails, ctx) => {
      emails.forEach((email, index) => {
        if (!email || email.trim() === "") {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Email cannot be empty",
            path: [index],
          });
        } else if (!z.string().email().safeParse(email).success) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `"${email}" is not a valid email address`,
            path: [index],
          });
        }
      });
    }),
});

export type WorkspaceInviteFormValues = z.infer<typeof workspaceInviteSchema>;
